module.exports = __webpack_public_path__ + "img/logo.1a6afe4c.png";